//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
  },
  props: {
    list: {
      type: Array,
    },
  },
};
